import { useEffect, useState } from 'react';

const DB_NAME = 'midia-share';
const STORE   = 'pending';

function dbGetAndClear(): Promise<File | null> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = e => (e.target as IDBOpenDBRequest).result.createObjectStore(STORE);
    req.onsuccess = e => {
      const db  = (e.target as IDBOpenDBRequest).result;
      const tx  = db.transaction(STORE, 'readwrite');
      const obj = tx.objectStore(STORE);
      const get = obj.get('file');
      get.onsuccess = () => {
        const file = get.result as File | undefined;
        obj.delete('file');
        tx.oncomplete = () => { db.close(); resolve(file ?? null); };
      };
      get.onerror = () => { db.close(); reject(get.error); };
    };
    req.onerror = () => reject(req.error);
  });
}

export function useSharedFile() {
  const [sharedFile, setSharedFile] = useState<File | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('shared') !== '1') return;
    window.history.replaceState({}, '', window.location.pathname);
    dbGetAndClear()
      .then(file => { if (file) setSharedFile(file); })
      .catch(() => {});
  }, []);

  const clearSharedFile = () => setSharedFile(null);
  return { sharedFile, clearSharedFile };
}
